import { FC } from "react";
import { Tooltip } from "antd";
import { HelpCircleIcon } from "@hugeicons/core-free-icons";
import styled from "styled-components";
import HugeIcon from "src/components/HugeIcon";
import { DialogNoteHelp } from "src/components/ui";
import { FieldLabel } from "../fields";

/**
 * A field's label, with what the field means on hover.
 *
 * It was the accent colour at 14px, indented 10px past the field it names,
 * with its help mark pushed to the far end of the column: a blue caption over
 * a blue box over blue digits, and a lone 12px glyph floating against the
 * dialog's right edge, next to nothing and explaining nothing in particular.
 * In this design the accent marks the one action a screen is FOR, which in
 * this dialog is the button that places the order.
 *
 * So it is the product's field label, and the mark sits beside the words it
 * explains. Clicking the label focuses the field, which is the point of a
 * label element and needs the field's id, so the id antd hands the control is
 * passed through to it.
 */

/* The note's help mark, which is written for the end of a sentence and so
   carries its own lead. Here the label's own gap does that. */
const Help = styled(DialogNoteHelp)`
  margin-left: 0;
`;

interface InputLabelDescriptionProps {
  label: string;
  description: string;
  /** The id of the control this labels, when it has one. */
  htmlFor?: string;
}

export const InputLabelDescription: FC<InputLabelDescriptionProps> = ({
  label,
  description,
  htmlFor,
}) => {
  return (
    <FieldLabel htmlFor={htmlFor}>
      {label}
      <Tooltip title={description}>
        <Help>
          <HugeIcon icon={HelpCircleIcon} size={13} />
        </Help>
      </Tooltip>
    </FieldLabel>
  );
};
